module.exports = __webpack_public_path__ + "static/media/ic_nav_profile.7a8fbb41.svg";